import { iconSize, iconStrokeWidth } from "@dashboard/components/icons";
import { Button, sprinkles } from "@saleor/macaw-ui-next";
import { ArrowLeft } from "lucide-react";
import { type MouseEvent } from "react";
import { Link } from "react-router-dom";

import { usePageBack } from "../usePageBack";

type Variant = "secondary" | "tertiary";

// 목록에서 연 상세 팝업 창에서는 뒤로가기가 목록으로 가지 않고 창을 닫는다 (2026-10-02 KST 추가).
// 팝업에는 메뉴가 없어 목록으로 가면 갈 곳이 없다.
// 팝업 안에서 다른 페이지(출고 처리·고객 프로필 등)로 옮겨 간 뒤에는 닫지 않고
// 직전 페이지로 돌아간다 (2026-10-06 KST 수정).
// 하단 바 뒤로가기와 같은 동작을 쓰도록 usePopupBack 으로 옮겼다 (2026-10-10 KST 수정).
// 팝업이 아닌 창에서도 직전 페이지가 있으면 to(상위 주소) 대신 그리로 돌아간다 (2026-11-03 KST 수정).
// 새 탭으로 열기(Ctrl/⌘·가운데 클릭)는 그대로 to 를 연다.
export const TopNavLink = ({ to, variant = "secondary" }: { to: string; variant?: Variant }) => {
  const pageBack = usePageBack();
  const goBackInsteadOfLink = (event: MouseEvent<HTMLAnchorElement>) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    if (pageBack()) {
      event.preventDefault();
    }
  };

  return (
    <Link to={to} className={sprinkles({ marginRight: 3 })} onClick={goBackInsteadOfLink}>
      <Button
        icon={<ArrowLeft size={iconSize.medium} strokeWidth={iconStrokeWidth} />}
        variant={variant}
        // 제목줄 버튼 규격(medium 29px)에 맞춘다. large 는 옆 버튼들보다 높았다 (2026-09-29 KST 수정)
        size="medium"
        data-test-id="app-header-back-button"
      />
    </Link>
  );
};
